<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconVideoOff_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M3.567 4.076a.625.625 0 0 0-.884.884l2.154 2.154A2.49 2.49 0 0 0 3.046 9.5v4.99a2.5 2.5 0 0 0 2.5 2.5h8.75a2.4 2.4 0 0 0 .382-.034l3.518 3.518a.625.625 0 0 0 .884-.884zM16.796 14.5v-5a2.5 2.5 0 0 0-2.5-2.5H8.258l8.373 8.373c.101-.273.165-.565.165-.873m1.25-4.375 2.725-2.271a.625.625 0 0 1 1.025.48v7.332c0 .53-.618.819-1.025.48l-2.725-2.271z"
        clip-rule="evenodd"
    />
</svg>
